import UpgradeLicenceDesktop from '@assets/licensing/UpgradeLicenceDesktop.png'
import UpgradeLicenceMobile from '@assets/licensing/UpgradeLicenceMobile.png'
import { useDialog } from '@globals/dialog/useDialogStore'
import { colors } from '@globals/themes/defaultTheme'
import { tabletQuery } from '@globals/themes/themeConstants'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { T, useT } from '@transifex/react'
import ContactToUpgradeButton from './ContactToUpgradeButton'
import { LICENSING_DIALOG_KEY } from './LicensingDialog'
import LicensingFeatures from './LicensingFeatures'
import { useGetLicenseFeatures } from './useGetLicenseFeatures'

const boxStyle: SxProps = {
  mt: { xs: -1.5, lg: -1.5 },
  mr: { xs: -1.5, lg: 0 },
  mb: { xs: 0, lg: -1.5 },
  ml: { xs: -1.5, lg: -3 },
  width: { lg: 400 },
  objectFit: 'cover',
}

const LicensingDialogContent: React.FC = () => {
  const t = useT()
  const isTablet = useMediaQuery(tabletQuery)
  const { isOpen } = useDialog(LICENSING_DIALOG_KEY)
  const { licenseFeatures } = useGetLicenseFeatures(isOpen)

  return (
    <Stack direction={isTablet ? 'column' : 'row'}>
      <Box
        component="img"
        src={isTablet ? UpgradeLicenceMobile : UpgradeLicenceDesktop}
        alt={t('Upgrade licence image')}
        sx={boxStyle}
      />
      <Stack direction="column">
        <Typography variant="h1" sx={{ mt: { xs: 0, lg: 1 } }}>
          <T _str="Take your Kudos program to new heights" />
        </Typography>
        <Stack
          direction="column"
          spacing={2}
          useFlexGap
          alignItems="flex-start"
          mb={{ xs: 0, sm: 1.5 }}
          sx={{ height: { xs: 'auto', lg: '100%' } }}>
          <Typography variant="body1" mt={{ xs: 1, sm: 0 }} color={colors.grayMedium}>
            <T _str="Unlock next-level features to help you drive even greater engagement, motivation, and impact" />
          </Typography>
          {licenseFeatures && <LicensingFeatures licenseFeatures={licenseFeatures} />}
          <Box sx={{ flexGrow: { xs: 0, lg: 1 } }} />
          <ContactToUpgradeButton />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default LicensingDialogContent
